var irreducible = require('./irreducible');
var isString = require('./isString');

module.exports = irreducible('String', isString);



/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form-templates-bootstrap/~/tcomb/lib/String.js
 ** module id = 96
 ** module chunks = 0
 **/